<template>
  <v-dialog v-model="dialogLocal" content-class="task-detail-dialog" max-width="1150">
    <v-card class="rounded-lg" tile>
      <v-card-title class="pb-0 pt-9 px-8 task-detail-dialog__header">
        <v-row align="center" no-gutters>
          <v-col cols="8" class="align-start d-flex justify-start">
            <div style="text-align: left">
              <h1 class="font-weight-medium ma-0 mb-3 text-h5">Detalhes da tarefa</h1>
              <div class="caption grey--text mt-1">
                <span class="font-weight-medium" style="text-transform: uppercase">
                  {{ erro.nome_teste || erro.sigla_teste || '—' }}
                </span>
                <span class="mx-2">•</span>
                <span class="font-weight-medium">{{ erro.entidade || '—' }}</span>
                <span class="mx-2">•</span>
                <span class="font-weight-medium">{{ erro.nome_validacao || '—' }}</span>
                <span class="mx-2">•</span>
                <span class="font-weight-medium">{{ erro.campo || '—' }}</span>
              </div>
            </div>
          </v-col>

          <v-col cols="4" style="position: relative; top: -10px; right: -23px">
            <button type="button" aria-label="Fechar detalhes da tarefa" @click="dialogLocal = false">
              <v-icon size="24">mdi-close</v-icon>
            </button>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row class="ma-0 task-detail-dialog__body" no-gutters>
        <v-col
          cols="12"
          :md="exibirHistorico ? 9 : 12"
          class="pr-0 task-detail-main"
          :class="{ 'pl-4': abaSelecionada === 0 }"
        >
          <div class="align-center d-flex" style="margin-top: 20px">
            <v-tabs v-model="abaSelecionada" class="flex-grow-1 px-4 task-detail-dialog__navigation" color="primary" grow>
              <v-tab>
                <v-icon left small>mdi-source-branch</v-icon>
                Fluxo
              </v-tab>
              <v-tab>
                <v-icon left small>mdi-play-circle-outline</v-icon>
                {{ erroEncerrado ? 'Evidências' : 'Executar tarefa atual' }}
              </v-tab>
            </v-tabs>
            <v-btn
              v-if="!historicoAberto && telaComEspacoParaHistorico"
              aria-label="Exibir histórico"
              class="mr-7"
              color="primary"
              icon
              small
              @click="historicoAberto = true"
            >
              <v-icon>mdi-dock-right</v-icon>
            </v-btn>
          </div>

          <v-tabs-items v-model="abaSelecionada" class="task-detail-dialog__tabs">
            <v-tab-item class="task-detail-dialog__tab">
              <v-card-text class="pa-0">
                <section class="lighten-4 pa-8 pl-5 task-detail-dialog__flow">
                  <h3 class="font-weight-bold grey--text mb-4 text--darken-1 text-overline">Fluxo de tratamento</h3>
                  <chart-flow
                    v-model="fluxoSelecionado"
                    :current-flow="fluxoAtual"
                    :current-step="statusErro"
                    :current-task="tarefaAtual.tipo_tarefa"
                    :flows="flows"
                  />
                </section>

                <v-divider class="ml-4 mr-6" />

                <v-row no-gutters>
                  <v-col cols="12" class="pl-4 pr-6 px-7 task-detail-dialog__content">
                    <div class="task-detail-dialog__sections">
                      <v-row dense>
                        <v-col cols="12">
                          <section class="task-current">
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <div class="caption font-weight-bold grey--text mb-1 text--darken-1">
                                  {{ erroEncerrado ? 'Última tarefa concluída' : 'Tarefa atual' }}
                                </div>
                                <p class="ma-0">{{ tituloTarefa }}</p>
                              </v-col>
                            </v-row>

                            <div class="task-current__objective">
                              <div class="caption font-weight-bold grey--text mb-1 text--darken-1">Descrição da tarefa</div>
                              <div>
                                <p class="body-2 mb-0" style="white-space: pre-line">{{ descricaoTarefaAtual }}</p>
                              </div>
                            </div>
                          </section>
                        </v-col>
                      </v-row>

                      <section class="task-context">
                        <div class="font-weight-bold grey--text text--darken-1 text-overline">Detalhes do Erro</div>

                        <v-row dense>
                          <v-col v-for="detalhe in detalhesErro" :key="detalhe.rotulo" cols="12" sm="3" class="pb-3">
                            <div class="caption grey--text mb-1">{{ detalhe.rotulo }}</div>
                            <div class="caption font-weight-medium">
                              <status-prioridade
                                v-if="detalhe.tipo === 'prioridade'"
                                compact
                                :prioridade="erro.prioridade || ''"
                              />
                              <status-erro v-else-if="detalhe.tipo === 'status'" :status="erro.status_erro" />
                              <v-tooltip v-else-if="detalhe.tipo === 'responsavel' && detalhe.valor.length > 20" top>
                                <template v-slot:activator="{ attrs, on }">
                                  <span v-bind="attrs" v-on="on">{{ detalhe.valor.slice(0, 20) }}…</span>
                                </template>
                                <span>{{ detalhe.valor }}</span>
                              </v-tooltip>
                              <span v-else>{{ detalhe.valor }}</span>
                            </div>
                          </v-col>
                          <v-col v-for="data in datasErro" :key="data.rotulo" cols="12" sm="3" class="pb-8 pt-3">
                            <div class="caption grey--text mb-1">{{ data.rotulo }}</div>
                            <status-prioridade v-if="data.tipo === 'prioridade'" compact :prioridade="erro.prioridade || ''" />
                            <span
                              v-else
                              class="align-center body-1 d-inline-flex"
                              :class="{ 'error--text font-weight-medium': data.vencida }"
                            >
                              <v-icon v-if="data.tipo !== 'bdgd'" small class="mr-2 mt-1">mdi-calendar-outline</v-icon>
                              {{ data.valor }}
                            </span>
                          </v-col>
                        </v-row>
                      </section>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

            <v-tab-item class="task-detail-dialog__tab">
              <template v-if="erroEncerrado">
                <encerrar-erro :erro="erro" :tarefa="tarefaAtual" somente-leitura />
              </template>
              <encaminhar-tarefa
                v-else-if="modoAdministrativo && tarefaAtual.tipo_tarefa === 'DEFINIR_ENCAMINHAMENTO'"
                :erro="erro"
                :tarefa="tarefaAtual"
                @executada="tarefaExecutada"
              />
              <justificar-erro
                v-else-if="tarefaAtual.tipo_tarefa === 'JUSTIFICAR_ERRO'"
                :bdgd="bdgd"
                :erro="erro"
                :tarefa="tarefaAtual"
                @executada="tarefaExecutada"
              />
              <analisar-erro
                v-else-if="tarefaAtual.tipo_tarefa === 'ANALISAR_ERRO'"
                :bdgd="bdgd"
                :erro="erro"
                :tarefa="tarefaAtual"
                @executada="tarefaExecutada"
              />
              <corrigir-primeiro v-else-if="aguardaAcaoCorrigirPrimeiro" :bdgd="bdgd" :erro="erro" @executada="tarefaExecutada" />
              <encerrar-erro
                v-else-if="modoAdministrativo && tarefaAtual.tipo_tarefa === 'ENCERRAR_ERRO'"
                :erro="erro"
                :tarefa="tarefaAtual"
                @executada="tarefaExecutada"
              />
              <v-container v-else-if="tarefaRequerGestao" fluid class="px-7 py-6">
                <v-alert class="mb-0" outlined type="info">Esta tarefa é executada pela gestão administrativa da BDGD.</v-alert>
              </v-container>
              <v-container v-else fluid class="px-7 py-6">
                <v-alert class="mb-0" outlined type="info">A execução desta tarefa ainda não está disponível.</v-alert>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-expand-x-transition>
          <v-col v-if="exibirHistorico" cols="12" md="3" class="d-flex timeline-column">
            <historico-tarefas
              class="flex-grow-1"
              :historico="erro.historico_tarefas || []"
              @alternar="historicoAberto = false"
            />
          </v-col>
        </v-expand-x-transition>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import EncaminharTarefa from './EncaminharTarefa.vue';
  import AnalisarErro from './AnalisarErro.vue';
  import EncerrarErro from './EncerrarErro.vue';
  import CorrigirPrimeiro from './CorrigirPrimeiro.vue';
  import HistoricoTarefas from './HistoricoTarefas.vue';
  import JustificarErro from './JustificarErro.vue';
  import ChartFlow from './ChartFlow.vue';
  import StatusErro from './StatusErro.vue';
  import StatusPrioridade from './StatusPrioridade.vue';
  import { fluxosTratamentoErro, obterFluxoAtual } from './fluxosTratamentoErro.js';

  const rotulosTipoTarefa = {
    DEFINIR_ENCAMINHAMENTO: 'Definir encaminhamento',
    TRATAR_REABERTURA: 'Tratar reabertura',
    ANALISAR_ERRO: 'Analisar erro',
    CORRIGIR_ERRO: 'Corrigir erro',
    JUSTIFICAR_ERRO: 'Justificar erro',
    CORRIGIR_ORIGEM: 'Corrigir origem',
    VALIDAR_CORRECAO: 'Validar correção',
    ENCERRAR_ERRO: 'Encerrar erro'
  };

  export default {
    name: 'DialogDetalheTarefa',

    components: {
      EncaminharTarefa,
      AnalisarErro,
      EncerrarErro,
      CorrigirPrimeiro,
      HistoricoTarefas,
      JustificarErro,
      ChartFlow,
      StatusErro,
      StatusPrioridade
    },

    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      bdgd: {
        type: Object,
        default: () => ({})
      },
      erro: {
        type: Object,
        default: () => ({})
      },
      modoAdministrativo: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        abaSelecionada: 0,
        fluxoSelecionado: null,
        historicoAberto: true
      };
    },

    computed: {
      dialogLocal: {
        get() {
          return this.dialog;
        },
        set(valor) {
          this.$emit('update:dialog', valor);
        }
      },

      etapaAtual() {
        return (
          {
            IDENTIFICADO: { rotulo: 'Definir encaminhamento' },
            EM_DIAGNOSTICO: { rotulo: 'Analisar erro' },
            EM_CORRECAO: { rotulo: 'Corrigir erro' },
            REABERTO: { rotulo: 'Corrigir erro' },
            AGUARDANDO_VALIDACAO: { rotulo: 'Validar resultado' },
            ENCERRADO: { rotulo: 'Fluxo concluído' },
            NAO_APLICAVEL: { rotulo: 'Erro não aplicável' }
          }[this.statusErro] || { rotulo: 'Tarefa atual' }
        );
      },

      statusErro() {
        return String(this.erro.status_erro || '').toUpperCase();
      },

      erroEncerrado() {
        return this.statusErro === 'ENCERRADO';
      },

      fluxoAtual() {
        return obterFluxoAtual(this.erro);
      },

      flows() {
        return fluxosTratamentoErro;
      },

      telaComEspacoParaHistorico() {
        return this.$vuetify.breakpoint.mdAndUp;
      },

      exibirHistorico() {
        return this.historicoAberto && this.telaComEspacoParaHistorico;
      },

      tarefaAtual() {
        if (this.aguardaAcaoCorrigirPrimeiro) return {};

        return Array.isArray(this.erro.tarefas) && this.erro.tarefas.length ? this.erro.tarefas[0] : {};
      },

      tarefaRequerGestao() {
        return ['DEFINIR_ENCAMINHAMENTO', 'ENCERRAR_ERRO'].includes(this.tarefaAtual.tipo_tarefa);
      },

      aguardaAcaoCorrigirPrimeiro() {
        const tarefa = Array.isArray(this.erro.tarefas) && this.erro.tarefas.length ? this.erro.tarefas[0] : null;

        return (
          this.erro.pode_executar_corrigir_primeiro === true ||
          (['EM_CORRECAO', 'REABERTO'].includes(this.statusErro) &&
            String(this.erro.encaminhamento_inicial || '').toUpperCase() === 'CORRIGIR_PRIMEIRO' &&
            (!tarefa ||
              (tarefa.tipo_tarefa === 'DEFINIR_ENCAMINHAMENTO' && tarefa.status_tarefa === 'CONCLUIDA') ||
              (tarefa.tipo_tarefa === 'ENCERRAR_ERRO' && tarefa.status_tarefa === 'CONCLUIDA')))
        );
      },

      tituloTarefa() {
        if (this.aguardaAcaoCorrigirPrimeiro) return 'Escolher fluxo';

        const tipo = this.tarefaAtual.tipo_tarefa;

        return rotulosTipoTarefa[tipo] || this.etapaAtual.rotulo;
      },

      tituloCabecalho() {
        return this.tituloTarefa;
      },

      datasErro() {
        return [
          { rotulo: 'Data inicial', valor: this.dataFormatada(this.erro.data_inicio) },
          {
            rotulo: 'Data final',
            valor: this.dataFormatada(this.erro.data_final),
            vencida: this.prazoVencido(this.erro.data_final, this.erro.data_conclusao)
          },
          { rotulo: 'Conclusão', valor: this.dataFormatada(this.erro.data_conclusao) }
        ];
      },

      descricaoTarefaAtual() {
        if (this.aguardaAcaoCorrigirPrimeiro) {
          return 'Escolha se o erro será corrigido ou justificado. A tarefa correspondente será criada ao finalizar a escolha.';
        }

        return this.tarefaAtual.descricao_tipo_tarefa || '—';
      },

      detalhesErro() {
        return [
          { rotulo: 'BDGD', valor: this.formatarBdgd(), tipo: 'bdgd' },
          { rotulo: 'Responsável', tipo: 'responsavel', valor: this.erro.responsavel?.nome || 'Não definido' },
          { rotulo: 'Prioridade de Correção', tipo: 'prioridade' },
          { rotulo: 'Status do erro', tipo: 'status' }
        ];
      }
    },

    methods: {
      tarefaExecutada() {
        const tarefaId = this.tarefaAtual.id;

        this.dialogLocal = false;
        this.$emit('executada', { erroId: this.erro.id, tarefaId });
      },

      formatarBdgd() {
        if (!this.bdgd || !this.bdgd.data_registro) return '—';

        const partes = [];

        if (this.bdgd.ordinaria) partes.push('Ordinária');

        partes.push(this.mesAnoFormatado(this.bdgd.data_registro));

        if (this.bdgd.versao !== null && this.bdgd.versao !== undefined) partes.push('v' + this.bdgd.versao);

        return partes.join(' ');
      },

      mesAnoFormatado(data) {
        const [ano, mes] = String(data).slice(0, 10).split('-');

        return ano && mes ? mes + '/' + ano : data;
      },

      dataFormatada(data) {
        if (!data) return '—';

        const [ano, mes, dia] = String(data).slice(0, 10).split('-');

        return ano && mes && dia ? dia + '/' + mes + '/' + ano : data;
      },

      prazoVencido(dataFinal, dataConclusao) {
        if (!dataFinal || dataConclusao) return false;

        const [ano, mes, dia] = String(dataFinal).slice(0, 10).split('-').map(Number);

        if (!ano || !mes || !dia) return false;

        const hoje = new Date();
        const prazo = new Date(ano, mes - 1, dia);

        hoje.setHours(0, 0, 0, 0);

        return prazo < hoje;
      }
    },

    watch: {
      erro: {
        immediate: true,
        handler() {
          this.fluxoSelecionado = this.fluxoAtual || fluxosTratamentoErro[0].id;
          this.historicoAberto = Array.isArray(this.erro.historico_tarefas) && this.erro.historico_tarefas.length > 0;
          if (this.erroEncerrado) this.abaSelecionada = 0;
        }
      }
    }
  };
</script>

<style scoped>
  .task-detail-dialog__tab {
    height: 560px;
    max-height: calc(100vh - 220px);
    max-width: 100%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .task-detail-dialog__tabs {
    max-width: 100%;
    min-width: 0;
  }

  .task-detail-dialog__content {
    min-width: 0;
  }

  .task-detail-dialog__body {
    flex-wrap: nowrap;
  }

  ::v-deep .v-dialog {
    overflow: hidden !important;
  }

  ::v-deep .task-detail-dialog > .v-card {
    max-height: calc(100vh - 48px);
  }

  .task-detail-dialog ::v-deep .v-window__container {
    max-width: 100%;
  }

  .task-detail-dialog__sections {
    display: grid;
    gap: 16px;
  }

  .task-current {
    display: grid;
    gap: 16px;
  }

  .task-current__objective {
    display: grid;
    gap: 8px;
  }

  .task-context {
    display: grid;
    gap: 16px;
  }

  .timeline-column {
    background-color: #d9d9d9;
    margin-top: 15px;
    transition:
      flex-basis 300ms ease,
      max-width 300ms ease,
      padding 300ms ease;
  }

  .task-detail-main {
    transition:
      flex-basis 300ms ease,
      max-width 300ms ease;
  }

  @media (max-width: 959px) {
    .task-detail-dialog__header {
      padding: 24px 24px 0 !important;
    }

    .task-detail-main {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .task-detail-dialog__navigation {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    .task-detail-dialog__flow {
      padding: 24px 16px !important;
    }

    .task-detail-dialog__content {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
</style>
